(function () {
  'use strict';

  var ANIMATE_ATTR = 'data-sg-animate';
  var TRIGGER_ATTR = 'data-sg-trigger';
  var DONE_ATTR = 'data-sg-anim-done';

  function setupSection(section) {
    var inner = section.querySelector('.sec__content-inner');
    if (!inner) return;

    var children = Array.from(inner.children);
    var slideIndex = 0;

    children.forEach(function (child) {
      var plusImg = child.querySelector('[data-sg-element="plus"]');

      if (plusImg) {
        plusImg.classList.add('sg-anim-plus');
      } else {
        var clip = document.createElement('div');
        clip.className = 'sg-anim-clip';
        inner.insertBefore(clip, child);
        clip.appendChild(child);
        child.classList.add('sg-anim-slide');
        child.dataset.sgSlideIndex = slideIndex++;
      }
    });
  }

  function triggerAnimation(section) {
    section.setAttribute(DONE_ATTR, '1');

    requestAnimationFrame(function () {
      section.querySelectorAll('.sg-anim-plus').forEach(function (img) {
        img.classList.add('sg-anim-rotating');
      });

      var slides = Array.from(section.querySelectorAll('.sg-anim-slide'));
      slides.forEach(function (el, i) {
        setTimeout(function () {
          el.classList.add('sg-anim-visible');
        }, i * 100);
      });
    });
  }

  function watchSection(section) {
    var triggerPct = parseInt(section.getAttribute(TRIGGER_ATTR) || '0', 10);
    var done = false;

    function check() {
      if (done) return;
      var rect = section.getBoundingClientRect();
      // threshold = posizione Y del trigger nel viewport
      // 0%  → section.top <= 0              (raggiunge il top)
      // 50% → section.top <= vh * 0.5       (metà schermo)
      // 100% → section.top <= vh            (entra appena nel viewport)
      var threshold = window.innerHeight * (triggerPct / 100);
      if (rect.top <= threshold && rect.bottom > 0) {
        done = true;
        triggerAnimation(section);
        window.removeEventListener('scroll', check, true);
      }
    }

    window.addEventListener('scroll', check, { passive: true, capture: true });
    // Controlla subito in caso la pagina sia già nella posizione corretta
    check();
  }

  /* ── SG Feature Accordion ───────────────────────────────── */
  function initAccordion() {
    document.querySelectorAll('.sg-acc-trigger').forEach(function (trigger) {
      function toggle() {
        var item   = trigger.closest('.sg-acc-item');
        var isOpen = item.classList.contains('is-open');
        // Close all open items in the same list
        var list = item.closest('.sg-acc-list');
        if (list) {
          list.querySelectorAll('.sg-acc-item.is-open').forEach(function (openItem) {
            openItem.classList.remove('is-open');
            openItem.querySelector('.sg-acc-trigger').setAttribute('aria-expanded', 'false');
          });
        }
        // Open clicked item if it was closed
        if (!isOpen) {
          item.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');
        }
      }

      trigger.addEventListener('click', toggle);
      // Keyboard support for div[role="button"]
      trigger.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          toggle();
        }
      });
    });
  }
  function init() {
    // SG Animated IWTO
    document.querySelectorAll('[' + ANIMATE_ATTR + '="true"]').forEach(function (section) {
      if (section.hasAttribute(DONE_ATTR)) return;
      setupSection(section);
      watchSection(section);
    });
    // SG Feature Accordion
    initAccordion();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();